module.exports = __webpack_public_path__ + "img/166.326d2d24.jpg";